import * as yup from 'yup'

import { 
    trimmedInputValues,
    capitalizeWordsInValue,
} from '../utils';

const MaterialItemValidation = yup.object().shape({
    categoryId: yup.number().required("Please select category"),
    brandId: yup.number().required("Please select brand"),
    productName: yup.string()
        //.transform((value) => capitalizeWordsInValue(value))
        .required('Please enter product name')
        .transform((value) => trimmedInputValues(value))
        .test('productNameLength', 'Product name should be more than 3 characters', value => value.length > 2),
    variantName: yup.string()
        //.transform((value) => capitalizeWordsInValue(value))
        .required('Please enter variant name')
        .transform((value) => trimmedInputValues(value))
        .test('variantNameLength', 'Variant name should be more than 3 characters', value => value.length > 2),
    UOM: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please select UOM'),
    UOMValue: yup.string()
        .transform((value) => trimmedInputValues(value))
        .test('uomValueValidation', 'Please enter any postive value', value => value != 0)
        .required('Please enter UOM value'),
    remarks: yup.string()
        .transform((value) => trimmedInputValues(value))
        .nullable()
})


const materialItemInitialState = {
    categoryId: null,
    brandId: null,
    productName: "",
    variantName: "",
    UOM: "",
    UOMValue: "",
    keywords: [],
    remarks: "",
}

export { MaterialItemValidation, materialItemInitialState }